import { createContext, useContext, useState } from "react";

const DemoContext = createContext(null);

export function DemoProvider({ children }) {
  const [active, setActive] = useState(false);
  return (
    <DemoContext.Provider value={{ active, start: () => setActive(true), stop: () => setActive(false) }}>
      {children}
    </DemoContext.Provider>
  );
}

export function useDemo() {
  const ctx = useContext(DemoContext);
  if (!ctx) throw new Error("useDemo debe usarse dentro de DemoProvider");
  return ctx;
}
